import { FalveyInsuranceQuoteInLoad } from '@store/ltl/types';
import { FalveyInsuranceQuote } from '@store/orders/types';

import { QuoteDetailsInsurance } from './types';

/**
 * Saved Quotes / History: `quoteParameters.ltlInsuranceQuote`.
 * Mirrors the legacy rule: insurance exists only when a premium was priced.
 */
export const toQuoteDetailsInsurance = (
  insuranceQuote?: FalveyInsuranceQuote | null,
): QuoteDetailsInsurance | undefined => {
  if (!insuranceQuote || insuranceQuote.premium <= 0) {
    return undefined;
  }
  return {
    premium: insuranceQuote.premium,
    serviceFee: insuranceQuote.serviceFee,
    declaredValue: insuranceQuote.declaredValue,
  };
};

/**
 * New Quote: `ltlQuoteState.falveyPricingQuote` + `ltlQuoteState.declaredValue`.
 * Mirrors the legacy rule: insurance exists once a declared value is set, even
 * while the Falvey price is still pending or failed (premium 0).
 */
export const toQuoteDetailsInsuranceFromLoad = (
  insuranceVals?: FalveyInsuranceQuoteInLoad,
  declaredValue?: number,
): QuoteDetailsInsurance | undefined => {
  if (!insuranceVals || !Boolean(declaredValue)) {
    return undefined;
  }
  return {
    premium: insuranceVals.quotePremium,
    serviceFee: insuranceVals.quoteServiceFee,
    declaredValue: declaredValue ?? insuranceVals.shippingSumInsured,
  };
};

/** Presence check only; each mapper above decides when insurance exists for its source. */
export const hasInsurance = (insurance?: QuoteDetailsInsurance) =>
  insurance !== undefined;
